module.exports = __webpack_public_path__ + "static/media/me.121646b2.jpg";